var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mt-5" },
    [
      _c("h2", { staticClass: "text-center" }, [
        _vm._v("Welcome to " + _vm._s(_vm.site_name)),
      ]),
      _vm._v(" "),
      _c("h4", { staticClass: "text-center" }, [
        _vm._v("Ready to rent skis and snowboards?"),
      ]),
      _vm._v(" "),
      _vm.module_type_enabled &&
      (_vm.module_type == "module_5_2" || _vm.module_type == "module_5_3")
        ? [
            _c(
              "v-row",
              { staticClass: "justify-center mt-10" },
              [
                _c(
                  "v-btn",
                  {
                    attrs: { color: "error mr-15" },
                    on: { click: _vm.multiplyReservation },
                  },
                  [_vm._v("\n                Daily / Multiday\n            ")]
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  { attrs: { color: "error" }, on: { click: _vm.setHalfDay } },
                  [_vm._v("\n                1/2 Day\n            ")]
                ),
              ],
              1
            ),
          ]
        : [
            !_vm.module_type_enabled ||
            (_vm.module_type_enabled &&
              _vm.module_type !== "module_12" &&
              _vm.module_type !== "module_18")
              ? _c(
                  "v-row",
                  { staticClass: "justify-center mt-10" },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { color: "error mr-15" },
                        on: { click: _vm.multiplyReservation },
                      },
                      [
                        _vm._v(
                          "\n                Daily / Multiday\n            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        attrs: { color: "error" },
                        on: { click: _vm.setNightSkiing },
                      },
                      [_vm._v("\n                Night Skiing\n            ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.module_type_enabled && _vm.module_type == "module_18"
              ? _c(
                  "v-row",
                  { staticClass: "justify-center mt-10" },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { color: "error mr-15" },
                        on: { click: _vm.multiplyReservation },
                      },
                      [
                        _vm._v(
                          "\n                Daily Reservation\n            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        attrs: { color: "error" },
                        on: { click: _vm.setNightSkiing },
                      },
                      [_vm._v("\n                Night Skiing\n            ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.module_type_enabled && _vm.module_type == "module_12"
              ? _c(
                  "v-row",
                  { staticClass: "justify-center mt-10" },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { color: "error mr-15 mb-5 mobile-size" },
                        on: { click: _vm.multiplyReservation },
                      },
                      [_vm._v("\n                Multiday\n            ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        attrs: { color: "error mb-5 mobile-size" },
                        on: { click: _vm.openModal },
                      },
                      [
                        _vm._v(
                          "\n                Daily (1/2 Day) / Twilight / Night Skiing / All Access Pass\n            "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }